// extracted by mini-css-extract-plugin
export var Post = "post-module--Post--6ecf4";
export var PostDetails = "post-module--PostDetails--936c2";
export var abstract = "post-module--abstract--ad02c";
export var date = "post-module--date--04ec0";
export var toc = "post-module--toc--5e97d";